import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../../style'
import Row from '../Row'
import Text from '../Text'
import { VARIANTS, SIZES, TAGS, getPalette, getPixelsFromSize } from './utils'

const commonStyles = `
    border: none;
    background: none;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    outline: none;
`
const WebButton = styled.button`${commonStyles}`
const WebLink = styled.a`${commonStyles}`

const Button = ({
    variant,
    size,
    title,
    fontColor: fntColor,
    disabled,
    width,
    contentContainerStyle,
    textProps,
    tag,
    ...rest
}) => {
    // fontColor, bgColor and borderColor are strings to be used with Colors[string]
    const { fontColor, bgColor, borderColor } = getPalette(variant, disabled)

    const {
        height,
        minWidth,
        borderRadius,
        paddingHorizontal,
        textSize,
    } = getPixelsFromSize(size)

    const Root = tag === TAGS.a ? WebLink : WebButton

    return (
        <Root
            type="button"
            disabled={disabled}
            {...rest}
        >
            <Row
                alignItems="center"
                justifyContent="center"
                style={{
                    backgroundColor: theme[bgColor],
                    height,
                    width,
                    minWidth,
                    paddingHorizontal,
                    borderRadius,
                    borderWidth: 1,
                    borderColor: theme[borderColor],
                    ...contentContainerStyle,
                }}
            >
                <Text
                    size={textSize}
                    color={fntColor || fontColor}
                    space="L"
                    uppercase
                    {...textProps}
                >
                    {title}
                </Text>
            </Row>
        </Root>
    )
}

Button.variants = Object.values(VARIANTS)

Button.propTypes = {
    variant: PropTypes.oneOf(Object.values(VARIANTS)),
    size: PropTypes.oneOf(Object.values(SIZES)),
    title: PropTypes.string,
    fontColor: PropTypes.oneOf(Object.keys(theme)),
    disabled: PropTypes.bool,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    contentContainerStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    textProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    tag: PropTypes.oneOf(Object.values(TAGS)),
    // Plus all props from native Button
}

Button.defaultProps = {
    variant: VARIANTS.default,
    size: SIZES.M,
    title: '',
    fontColor: null,
    disabled: false,
    width: '100%',
    contentContainerStyle: {},
    textProps: {},
    tag: TAGS.button,
}

export default Button
